<template>
  <div id="contenedor-obrassolicitudes-configuracion-etiquetas">
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado-etiquetas
            modulo="obrasSolicitudes">
          </listado-etiquetas>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ListadoEtiquetas from '@/components/administracion/configuracion/plantillas/etiquetas/listado/Desktop.vue';

export default {
  name: 'ObrasSolicitudesConfiguracionEtiquetas',
  data() {
    return {};
  },
  components: { ListadoEtiquetas },
};
</script>

<style lang="scss">

</style>
